import { render, staticRenderFns } from "./dr-grid.vue?vue&type=template&id=647fa0c6"
import script from "./dr-grid.vue?vue&type=script&lang=js"
export * from "./dr-grid.vue?vue&type=script&lang=js"
import style0 from "./dr-grid.vue?vue&type=style&index=0&id=647fa0c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports